
const digest = '1a5f9cf4ee8d695c53d32be94d5fd2be3cb44d248d6e70338a9b46acddfb01f7';
const classes = {"wrapper":"_wrapper_93t76_1","header":"_header_93t76_8","content":"_content_93t76_13"};
const css = `._wrapper_93t76_1 {
  font-family: Rubik, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 10px;
}
._wrapper_93t76_1 ._header_93t76_8 {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #eaedf3;
}
._wrapper_93t76_1 ._content_93t76_13 {
  display: flex;
  flex-direction: column;
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  